import { getZonedDate } from '@eika-infrastruktur/date';
export const transferInitialState = {
    fromAccount: undefined,
    toAccount: undefined,
    showFromAccounts: false,
    showToAccounts: false,
    amount: undefined,
    note: '',
    ownText: undefined,
    transferDate: undefined,
};
export const getFutureState = (futurePayment) => ({
    ...transferInitialState,
    transferDate: getZonedDate(futurePayment.date),
    note: futurePayment.description || '',
    amount: Math.abs(futurePayment.amount),
    showFromAccounts: false,
    showToAccounts: false,
    toAccount: futurePayment.toAccount.accountNumber,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90cmFuc2FjdGlvbi9UcmFuc2Zlci9mb3JtL3N0YXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxZQUFZLEVBQWEsTUFBTSwwQkFBMEIsQ0FBQztBQVNuRSxNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBa0I7SUFDL0MsV0FBVyxFQUFFLFNBQVM7SUFDdEIsU0FBUyxFQUFFLFNBQVM7SUFDcEIsZ0JBQWdCLEVBQUUsS0FBSztJQUN2QixjQUFjLEVBQUUsS0FBSztJQUNyQixNQUFNLEVBQUUsU0FBUztJQUNqQixJQUFJLEVBQUUsRUFBRTtJQUNSLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLFlBQVksRUFBRSxTQUFTO0NBQzFCLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsQ0FBQyxhQUFxQyxFQUFpQixFQUFFLENBQUMsQ0FBQztJQUNyRixHQUFHLG9CQUFvQjtJQUN2QixZQUFZLEVBQUUsWUFBWSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUM7SUFDOUMsSUFBSSxFQUFFLGFBQWEsQ0FBQyxXQUFXLElBQUksRUFBRTtJQUNyQyxNQUFNLEVBQUUsSUFBSSxDQUFDLEdBQUcsQ0FBQyxhQUFhLENBQUMsTUFBTSxDQUFDO0lBQ3RDLGdCQUFnQixFQUFFLEtBQUs7SUFDdkIsY0FBYyxFQUFFLEtBQUs7SUFDckIsU0FBUyxFQUFFLGFBQWEsQ0FBQyxTQUFTLENBQUMsYUFBYTtDQUNuRCxDQUFDLENBQUMifQ==